import { useParams } from "react-router-dom";
import { TitlePage } from "../../components/ui/TitlePage";
import { useEffect, useState } from "react";
import { api, urls } from "../../services/api";
import { INewsComplet } from "../../types/news";
import { ListImages } from "../../components/ui/ListImages";
import { ListFiles } from "../../components/ui/ListFiles";
import { OtherNews } from "../../components/sections/OtherNews";
import { useApp } from "../../context/App";
import { NewsShare } from "../../components/sections/NewsShare";
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import { Helmet } from "react-helmet-async";
import DOMPurify from 'dompurify';
import { ScrollProgress } from "../../components/ui/ScrollProgress";

export function NewsScreen() {

	let { id } = useParams();
	const { mobile, configApiURL } = useApp()

	let pasta_foto = `${configApiURL}public/portaladm-pmitajai/noticias/foto/`;

	const [news, setNews] = useState<INewsComplet>(
		{
			content: '',
			description: '',
			photos: [],
			published: '',
			title: 'Carregando...',
			category: 0,
			gallery: [],
			subtitle: '',
			files: [],
			periodoEleitoral: '',
			download: '',
			photographer: '',
		}
	)

	const [content, setContent] = useState<string>('')

	useEffect(() => {
		//Fancybox para imagem dentro do conteúdo
		Fancybox.bind('[data-fancybox]');

		(async () => {
			try {

				const response = await api.get<INewsComplet>(urls.NewsById + id)



				setNews(response.data)

				const replaceSpam = response.data.content.replace('<span style="color:black; font-family:var(--roboto); font-size:3vw">', '')
				setContent(replaceSpam.replace('</span>', ''))

			} catch (error) {
				// error silent
				//window.location.href = domain;
			}

		})()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])



	return (
		<div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors font-roboto items-center justify-start">
			<ScrollProgress />
			<Helmet>
				<title>{news.title} | Município de Itajaí</title>
				<meta name="description" content={news.description || news.subtitle} />

				{/* Open Graph */}
				<meta property="og:title" content={news.title} />
				<meta property="og:description" content={news.description || news.subtitle} />
				<meta property="og:type" content="article" />
				<meta property="og:url" content={window.location.href} />
				{news.photos && news.photos[0] && (
					<meta property="og:image" content={pasta_foto + news.photos[0]} />
				)}

				{/* Twitter Card */}
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={news.title} />
				<meta name="twitter:description" content={news.description || news.subtitle} />
				{news.photos && news.photos[0] && (
					<meta name="twitter:image" content={pasta_foto + news.photos[0]} />
				)}
			</Helmet>

			{!news.periodoEleitoral ? (
				<>
					{mobile && <div className="h-20" />}
					<TitlePage title={news?.title.toUpperCase()} />

					<div className="flex flex-col w-11/12 lg:w-3/5 items-center justify-start pb-12 lg:pb-8 mt-6">
						<div className="text-gray-700 dark:text-gray-300 text-lg lg:text-base italic font-medium mb-4 lg:mb-4 text-left self-start">
							{news.subtitle}
						</div>

						<div className="self-start text-gray-500 dark:text-gray-400 text-sm lg:text-xs font-normal tracking-wide mb-8 lg:mb-6 text-left">
							Data de inclusão: {news.published.replace("-", "")}
						</div>

						{!!news.photos[0] && (
							<a
								href={pasta_foto + news.photos[0]}
								data-fancybox
								data-caption={"Foto: " + news?.photographer}
								data-src={pasta_foto + news.photos[0]}
								className="w-full lg:w-3/4 mb-10 overflow-hidden rounded-2xl lg:rounded-xl shadow-sm cursor-zoom-in group"
							>
								<div className="relative w-full aspect-video lg:aspect-auto">
									<img
										src={pasta_foto + news.photos[0]}
										className="w-full h-full lg:h-auto object-cover transition-transform duration-500 group-hover:scale-105"
										alt="Imagem da notícia"
									/>
									{!!news.photographer && (
										<div className="absolute bottom-0 left-0 w-full bg-black/50 backdrop-blur-sm text-white text-xs lg:text-[10px] px-4 py-2">
											Foto: {news?.photographer}
										</div>
									)}
								</div>
							</a>
						)}

						<div
							className="w-full text-base font-light text-gray-800 dark:text-gray-200 text-left lg:text-justify mb-10 
							[&_p]:mt-4 [&_p]:mb-4 [&_p]:font-normal [&_p]:text-base [&_p]:leading-relaxed [&_p]:tracking-wide
							[&_a]:text-primary dark:[&_a]:text-primary-light [&_a]:font-medium [&_a]:underline 
							[&_img]:rounded-xl [&_img]:my-6"
							dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content || news.content) }}
						/>

						{news.files.length > 0 && <ListFiles files={news.files} />}
						{news.gallery.length > 0 && <ListImages gallery={news.gallery} download={news.download} />}

						<NewsShare />
						<OtherNews idNews={id || ''} categorieNewsId={news.category} />
					</div>
				</>
			) : news.periodoEleitoral === 'Sim' ? (
				<>
					{mobile && <div className="h-20" />}
					<TitlePage title="Período Eleitoral" />
					<div className="flex flex-col w-11/12 lg:w-3/5 items-center justify-start pb-12 lg:pb-8 mt-6">
						<div
							className="w-full text-base font-light text-gray-800 dark:text-gray-200 text-left lg:text-justify mb-10 
							[&_p]:mt-4 [&_p]:mb-4 [&_p]:font-normal [&_p]:text-base [&_p]:leading-relaxed [&_p]:tracking-wide
							[&_strong]:text-gray-900 dark:[&_strong]:text-white [&_strong]:font-bold"
						>
							<p>Em cumprimento à legislação eleitoral (Lei 9.504/1997), todas as publicações anteriores do Instagram da Prefeitura de Itajaí serão arquivadas e os comentários desabilitados de <strong>06 de julho a 06 de outubro de 2024.</strong> O Facebook, Youtube e Flickr serão desativados neste período.</p>
							<p>Em nosso site e no Instagram, serão publicadas apenas notícias de utilidade pública.</p>
							<p><strong>Mas fique tranquilo: </strong>todos os serviços do portal itajai.sc.gov.br continuarão funcionando normalmente.</p>
						</div>
					</div>
				</>
			) : null}
		</div>
	);
}